import { useDispatch } from "react-redux";
import { useLocation, useRouteMatch } from "react-router-dom";
import jwt_decode from "jwt-decode";
import {
  magicLoginReceivingToken,
  magicLoginRequestToken,
} from "../../redux/actions";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import { Controller, useForm, useWatch } from "react-hook-form";
import { Error } from "../Error";

const EMAIL_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

export const NotLoggedIn: React.FC = () => {
  const dispatch = useDispatch();
  const { control, errors, handleSubmit } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const {
    params: { resourceId, resourceType },
  } = useRouteMatch<{ resourceType: string; resourceId: string }>();

  const token = new URLSearchParams(useLocation().search).get("token");
  if (token) {
    const { upn } = jwt_decode<{ upn: string }>(token);
    dispatch(magicLoginReceivingToken(upn, token));
  }

  const handleKeyPress = (e: any) => {
    if (e.code === "Enter") {
      e.preventDefault();
      handleSubmit(onSubmit)();
    }
  };

  const onSubmit = (data: { email: string }) =>
    dispatch(magicLoginRequestToken(resourceType, resourceId, data.email));

  const { email } = useWatch({
    control,
    name: ["email"],
  });

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      onKeyDown={(e) => handleKeyPress(e)}
    >
      <Dialog open maxWidth="md" fullWidth>
        <DialogTitle>Access a Shared Resource</DialogTitle>
        <DialogContent>
          <p>
            This is a private resource. If you have been granted access to the
            resource please enter your email address below.
          </p>
          <Controller
            control={control}
            name="email"
            rules={{ pattern: EMAIL_REGEX }}
            as={
              <TextField
                label="Email Address"
                data-test="closure-reason"
                required
                fullWidth
                variant="outlined"
              />
            }
          />
          {errors.email && <Error>Enter a valid email address</Error>}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSubmit(onSubmit)}
            color="primary"
            disabled={!email}
            type="submit"
          >
            Access
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
};
